import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import { Layout, Dropdown, Menu, Avatar, Icon } from 'antd';

import Emitter from '../../services/emitter';
import History from '../../util/history';
import CONSTANT from '../../constant';
import { parseRoute, hasDarwin, showErrorMessage, showSuccessMessage, safeHttps } from '../../util';
import mElectronApi from '../../util/electron';
import Config from '../../config';

import LanguageAction from '../../reducers/language/action';
import MenuAction from '../../reducers/menu/action';
import ProjectAction from '../../reducers/project/action';
import UserAction from '../../reducers/user';

import './header.less';
import avatarImg from '../../resource/img/avatar.svg';
import visitorImg from '../../resource/img/visitor-avatar.svg';

const RequestStatus = CONSTANT.REQUEST_STATUS;
const MenuLanguageKey = 'MENU.LANGUAGE';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.project.name
        };
    }

    componentWillReceiveProps(nextProps) {
        const { project } = this.props;
        const nextProject = nextProps.project;
        if (project.name !== nextProject.name) {
            this.setState({
                value: nextProject.name
            });
        }
    }

    /**
     * 菜单禁用状态
     *
     * @param {any} data
     * @returns
     */
    disabled = (data) => {
        const { menu } = this.props;
        const { operate } = menu;
        if (_.has(data, 'operate') && _.has(operate, data.operate)) {
            return !operate[data.operate];
        }
        return false;
    };

    /**
     * 主菜单
     *
     * @author LiHuan
     * @returns
     */
    mainDropdown() {
        const { menu, visibleChange } = this.props;
        return (
            <Dropdown
                trigger={['click']}
                overlay={this.mainMenu()}
                onVisibleChange={visible => visibleChange('main', visible)}>
                <span id="mainMenuTrigger"
                    className={`menu-icon menu-trigger ${menu.main ? 'active' : ''}`}>
                    <span className="menu-bar"></span>
                    <span className="menu-bar menu-middle-bar"></span>
                    <span className="menu-bar"></span>
                </span>
            </Dropdown>
        );
    }

    /**
     * 帐号菜单
     *
     * @returns
     */
    accountDropdown = () => {
        const { account } = this.props;
        if (account.checkAccountRequest === RequestStatus.PENDING) {
            return this.checkAccountMenu();
        }
        return account.isLogin ? this.userMenu() : this.emptyUserMenu();
    };

    /**
     * 同步列表
     *
     * @returns
     */
    syncList() {
        const status = this.props.project['syncLabel'];
        let className = status;
        if (status === 'noNetWork') {
            className = 'fail';
        }
        const statusMsg = {
            'syncing': 'PROJECT.STATUS.SYNCING',
            'noNetWork': 'PROJECT.STATUS.NONETWORK',
            'success': 'PROJECT.STATUS.SUCCESS',
            'fail': 'PROJECT.STATUS.FAIL'
        };
        const { intlr } = this.props;
        const { messages } = intlr;
        return (
            <div className={`sync-status ${className}`}>
                <Icon type="sync" style={{ cursor: 'pointer' }} spin={status === 'syncing'}
                    onClick={() => this.handleSync(status)} />
                {status && <span>{messages[statusMsg[status]]}</span>}
            </div>
        );
    }

    handleSync = (status) => {
        if (status === 'syncing') {
            return;
        }
        Emitter.emit('SyncList', () => {}, () => {});
    }

    /**
     * 登陆后的菜单
     *
     * @returns
     */
    userMenu = () => {
        const { menu, account, visibleChange } = this.props;
        return (
            <Dropdown
                trigger={['click']}
                overlay={this.userDropdownMenu()}
                onVisibleChange={visible => visibleChange('user', visible)}>
                <span id="userMenuTrigger"
                    className={`user-menu menu-trigger ${menu.user ? 'active' : ''}`}>
                    {(account.data && account.data.userName) || '--'}&emsp;
                    <Avatar icon="user" src={(account.data && safeHttps(account.data.headpic)) || avatarImg} />
                </span>
            </Dropdown>
        );
    };

    /**
     * 用户登录后的下拉菜单
     *
     * @returns
     */
    userDropdownMenu = () => {
        const { intlr } = this.props;
        const { messages } = intlr;
        return (
            <Menu className="header-dropdown-menu" onClick={this.handleUserMenuClick.bind(this)}>
                <Menu.Item key="user:clouddata">
                    {messages['MENU.CLOUDLIST']}
                </Menu.Item>
                {/* <Menu.Item key="user:ifttt">
                    {messages['IFTTT.TITLE']}
                </Menu.Item> */}
                <Menu.Item key="user:profile">
                    {messages['USER.PROFILE']}
                </Menu.Item>
                {/* <Menu.Divider /> */}
                {/* <Menu.Item key="menu:logout">
                    {messages['USER.LOGOUT']}
                </Menu.Item> */}
            </Menu>
        );
    };

    /**
     * 空菜单
     *
     * @returns
     */
    emptyUserMenu = () => {
        return (
            <div className="user-menu menu-trigger" key="login" onClick={() => History.replace(parseRoute('/login'))}>
                <Avatar icon="user" src={visitorImg} />
            </div >
        );
    };

    /**
     * 检查登录时的状态
     *
     * @returns
     */
    checkAccountMenu = () => {
        return (
            <span className="user-menu menu-trigger">
                <Avatar icon="loading" />
            </span>
        );
    };

    /**
     * 子菜单
     *
     * @param {any} data
     * @returns
     */
    menuItem = (data) => {
        const { intlr } = this.props;
        const { menus } = data;
        if (data.key === MenuLanguageKey) {
            const langs = intlr.langs;
            const info = intlr.data;
            let langKey = intlr.langKey || '';
            let isHasLanguage = langKey === 'en' ? '' : '/Language';
            return (
                <Menu.SubMenu className="header-dropdown-menu" key={data.key} title={intlr.messages['MENU.LANGUAGE'] + isHasLanguage}>
                    {langs.map(lang => <Menu.Item key={`${data.key}${lang}`}>{info[lang].name}</Menu.Item>)}
                </Menu.SubMenu>
            );
        }
        if (!_.isEmpty(menus)) {
            return (
                <Menu.SubMenu className="header-dropdown-menu" key={data.key} title={intlr.messages[data.key]}>
                    {menus.map(menu => this.menuItem(menu))}
                </Menu.SubMenu>
            );
        }
        return (
            <Menu.Item key={data.key}
                link={data.link}
                disabled={this.disabled(data)}>
                <span className="menu-label">{intlr.messages[data.key]}</span>
                {
                    mElectronApi.has('shortcutkey') && !_.isEmpty(data.shortcutKey) &&
                    <span className="menu-shortcut-key">
                        {
                            hasDarwin()
                                ? data.shortcutKey[1]
                                : data.shortcutKey[0]
                        }
                    </span>
                }
            </Menu.Item>
        );
    };

    /**
     * 主菜单
     *
     * @returns
     */
    mainMenu = () => {
        const { menu } = this.props;
        const { menus } = menu;
        return (
            <Menu className="header-dropdown-menu" subMenuOpenDelay={0.1} onClick={this.handleMenuClick}>
                {menus.map(menu => this.menuItem(menu))}
            </Menu>
        );
    };

    handleMenuClick = ({ key, item }) => {
        if (key && item) {
            const { change, visibleChange } = this.props;
            const { link } = item.props;
            if (key.indexOf(MenuLanguageKey) === 0) {
                change(key.replace(MenuLanguageKey, ''));
            } else if (link) {
                History.push(link);
            } else {
                Emitter.emit('ClickMenu', key);
            }
            visibleChange('main', false);
        }
        return true;
    }

    handleUserMenuClick = (item) => {
        const { logout, urlToken, visibleChange } = this.props;
        if (item.key === 'menu:logout') {
            logout(
                () => showSuccessMessage.bind(this)('USER.LOGOUT.SUCCESS.MSG'),
                () => showErrorMessage.bind(this)('USER.LOGOUT.FAIL.MSG')
            );
        }
        if (item.key === 'user:clouddata') {
            urlToken((data) => {
                mElectronApi.openLink(null, `${Config.link.cloud_data}?token=${data.urltoken}`);
            }, err => showErrorMessage.bind(this)(null, err.code));
        }
        if (item.key === 'user:profile') {
            History.push(parseRoute('/profile'));
        }
        if (item.key === 'user:ifttt') {
            History.push(parseRoute('/user/ifttt'));
        }
        visibleChange('user', false);
        return true;
    }

    render() {
        const { isLogin } = this.props.account;
        return (
            <Layout.Header className="header">
                <section className="header-cell main-menu-cell">
                    {this.mainDropdown()}
                    {isLogin && this.syncList()}
                </section>
                {/* <section className="header-cell project-name-cell">
                </section> */}
                <section className="header-cell user-menu-cell">
                    {this.accountDropdown()}
                </section>
            </Layout.Header>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr,
    menu: state.menu,
    project: state.project,
    account: state.account
});

const mapDispatchToProps = dispatch => ({
    change: lang => dispatch(LanguageAction.change(lang)),
    urlToken: (successCb, failCb) => dispatch(UserAction.urlToken(successCb, failCb)),
    logout: (successCb, failCb) => dispatch(UserAction.logout(successCb, failCb)),
    visibleChange: (type, visible) => dispatch(MenuAction.visibleChange(type, visible)),
    rename: (isRename) => dispatch(ProjectAction.rename(isRename))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);